export enum PartiesEnum {
  SEED = 'SEED',
  TECHNICAL = 'TECHNICAL',
}

export enum StorageTypeEnum {
  RENT = 'RENT',
  MAIN = 'MAIN',
  RESERVE = 'RESERVE',
  SEED = 'SEED',
  GOODS = 'GOODS',
}
